import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_HR_CONTRACT_SUBSCRIPTION } from "my-hr/graphql";
import { MY_LEAVE_GET_IS_VIEWER_CONTRACT } from "my-leave/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyLeaveIsViewerContract = ({
  contract,
}: {
  contract: string | null;
}) => {
  const { data, loading, error, refetch } = useQuery(
    MY_LEAVE_GET_IS_VIEWER_CONTRACT,
    {
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      skip: !contract,
      variables: { contract },
    },
  );

  useSubscription(MY_HR_CONTRACT_SUBSCRIPTION, {
    onData: () => {
      refetch();
    },
  });

  return { data: data?.isViewerContract, loading, error };
};

export default useMyLeaveIsViewerContract;
